import Modal from '@xo-union/tk-component-modals';
import React from 'react';
import styles from './PublishWebsiteModal.scss';
import { useSelectedThemeQuery, useWeddingWebsiteQuery } from '../../../generated/graphql';
import classNames from 'classnames';
import VerifyEmailModalContent from './Subcomponents/VerifyEmailModalContent/VerifyEmailModalContent';
import PublishWebsiteModalContent from './Subcomponents/PublishWebsiteModalContent/PublishWebsiteModalContent';
import { usePublishModalRegistryExp } from '../../../hooks/experiment/usePublishModalRegistryExp';
import PublishWebsiteModalContentVariant from './Subcomponents/PublishWebsiteModalContentVariant/PublishWebsiteModalContentVariant';

interface PublishWebsiteModalProps {
  onClose: () => void;
}

const PublishWebsiteModal = ({ onClose }: PublishWebsiteModalProps) => {
  const { data: wwsData } = useWeddingWebsiteQuery();
  const { data: selectedThemeData } = useSelectedThemeQuery();
  const { isVariant } = usePublishModalRegistryExp();

  const isUserEmailVerified = wwsData?.member?.isEmailVerified || false;
  const isWebsitePublished = wwsData?.weddingWebsite?.state === 'published';
  const userEmail = wwsData?.member?.email;
  const wwsUrl = wwsData?.weddingWebsite?.wwsUrl;

  const designerUrl = selectedThemeData?.theme?.designerUrl;

  const shouldRenderVerifyEmailModal = !isUserEmailVerified;
  const shouldRenderPublishWebsiteModal = isUserEmailVerified && isWebsitePublished;

  const shouldRender = (shouldRenderVerifyEmailModal || shouldRenderPublishWebsiteModal) && isVariant !== undefined;
  if (!shouldRender) {
    return null;
  }

  return (
    <Modal
      size="lg"
      onClose={onClose}
      className={classNames(styles.PublishWebsiteModal__Modal, {
        [styles.PublishWebsiteModal__ConfettiBackground]: shouldRenderPublishWebsiteModal,
      })}
    >
      <div className={styles.PublishWebsiteModal__Content}>
        {shouldRenderVerifyEmailModal && <VerifyEmailModalContent userEmail={userEmail} />}
        {shouldRenderPublishWebsiteModal && !isVariant && (
          <PublishWebsiteModalContent wwsUrl={wwsUrl} designerUrl={designerUrl} />
        )}
        {shouldRenderPublishWebsiteModal && isVariant && <PublishWebsiteModalContentVariant wwsUrl={wwsUrl} />}
      </div>
    </Modal>
  );
};

export default PublishWebsiteModal;
